<div class="search-dialog ac-flex-col ac-gap-lg ac-pd-lg">
  <div class="ac-flex ac-algn-ctr ac-gap-sm">
    <mat-form-field
      subscriptSizing="dynamic"
      class="game-name-search ac-form-field-sm ac-rounded"
    >
      <div matPrefix class="prefix">
        <ac-icon iconKey="hr:search" [size]="32" />
      </div>
      <input
        matInput
        type="string"
        [formControl]="nameSearchFormControl"
        placeholder="Search for games"
      />
    </mat-form-field>
    <button
      mat-icon-button
      class="close-btn ac-icon-btn-sm"
      (click)="dialogRef.close()"
    >
      <ac-icon iconKey="hr:xmark" [size]="20" />
    </button>
  </div>

  <div class="games-list">
    @if (gamesLoading()) {
    <div class="loading ac-flex-col ac-gap-sm ac-ctr">
      <ac-loading [size]="75" />
    </div>
    } @else { @for (game of games(); track game.game_id) {
    <app-game-card
      [game]="game"
      (click)="dialogRef.close()"
      analyticsPageArea="search_games_dialog"
    />
    } @empty {
    <div class="no-games-found ac-flex-col ac-gap-sm ac-ctr">
      <div class="search ac-flex ac-ctr">
        <ac-icon iconKey="hr:search" [size]="32" />
      </div>
      <div class="ac-title-lg">No games match your search</div>
      <div class="ac-label ac-body-md">
        Please try searching for another game
      </div>
    </div>
    } }
  </div>
</div>
